module.exports = __webpack_public_path__ + "static/media/4.83e019f1.svg";